import {useLocation, useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {Label} from "semantic-ui-react";

export function LoginComponent() {

    let navigate = useNavigate();
    let location = useLocation();
    let auth = useAuth();


    // @ts-ignore
    let from = location.state?.from?.pathname || "/";

    async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        let formData = new FormData(event.currentTarget);
        let env = formData.get("environment") as string;
        let token = formData.get("token") as string;

        try {
            const context = await auth.signInByToken(token, env);
            if (context.user) {
                navigate(from, {replace: true});
            } else {
                alert("Invalid creds")
            }
        } catch (er) {
            alert("something went wrong")
        }

    }


    return (<div>
        <p>You must log in to view the page at {from}</p>

        <form onSubmit={handleSubmit}>
            <label>
                Environment: <input name="environment" type="text"/>
            </label>
            <Label>
                TOken : <input name={"token"} type={"text"}/>
            </Label>
            <button type="submit">Login</button>
        </form>
    </div>)
}
